// extracted by mini-css-extract-plugin
export default {"not_path":"NotPath_not_path__IuImy","not_path_inner_con":"NotPath_not_path_inner_con__uax80","not_path_backButton":"NotPath_not_path_backButton__Dexey"};